import { Link } from "react-router-dom";
import { useFetch } from "../hooks/useFetch";
import { getBlogPosts } from "../services/firestore";
import { LoadingGrid } from "../components/ui/LoadingState";
import SEO from "../components/ui/SEO";
import "./Blog.css";

export default function BlogPage() {
  const { data: posts, loading, error } = useFetch(getBlogPosts, []);

  return (
    <main className="blog-page" aria-label="Main content">
      <SEO
        title="Blog"
        description="Articles and write-ups by Rajat Shenoi on software development, projects, and learning."
        url="/blog"
      />
      <div className="container">
        <h1 className="blog-page__title">Blog</h1>
        <p className="blog-page__subtitle">Thoughts, tutorials, and stories from my journey.</p>

        {loading && <LoadingGrid count={3} />}

        {error && (
          <div className="blog-error">
            <p className="blog-error__text">Failed to load blog posts.</p>
          </div>
        )}

        {!loading && !error && posts.length === 0 && (
          <div className="blog-empty">
            <div className="blog-empty__icon">&#9998;</div>
            <p className="blog-empty__text">No blog posts yet. Check back soon!</p>
          </div>
        )}

        {!loading && !error && posts.length > 0 && (
          <div className="blog-grid">
            {posts.map((post) => (
              <Link to={`/blog/${post.slug}`} key={post.id} className="blog-card">
                {post.cover_image_url && (
                  <img
                    className="blog-card__image"
                    src={post.cover_image_url}
                    alt={post.title}
                    loading="lazy"
                  />
                )}
                <div className="blog-card__body">
                  {post.date && (
                    <span className="blog-card__date">{post.date}</span>
                  )}
                  <h2 className="blog-card__title">{post.title}</h2>
                  {post.excerpt && (
                    <p className="blog-card__excerpt">{post.excerpt}</p>
                  )}
                  {post.tags && post.tags.length > 0 && (
                    <div className="blog-card__tags">
                      {post.tags.map((tag) => (
                        <span key={tag} className="blog-card__tag">{tag}</span>
                      ))}
                    </div>
                  )}
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </main>
  );
}
